/*
 * This file is part of vospace-ui
 * Copyright (C) 2021 Istituto Nazionale di Astrofisica
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import Vue from 'vue'
import App from './App.vue'
import store from './store.js'
import './plugins/bootstrap-vue'

import { BootstrapVue } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.config.productionTip = false

import VueRouter from 'vue-router'
Vue.use(VueRouter)
import router from './router.js'

let vm = new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')

window.deleteNode = function(path) {
  store.commit('setNodesToDelete', [path]);
  vm.$bvModal.show('confirm-delete-modal');
}
window.shareNode = function(path, groupRead, groupWrite) {
  store.commit('setNodeToShare', { path, groupRead, groupWrite });
  vm.$bvModal.show('share-modal');
}
window.renameNode = function(path) {
  store.commit('setNodeToRename', path);
  vm.$bvModal.show('rename-modal');
}
window.moveNode = function(path) {
  moveOrCopy(path, 'move');
}
window.copyNode = function(path) {
  moveOrCopy(path, 'copy');
}
window.openNodeInMoveOrCopyModal = function(event, path) {
  event.preventDefault();
  event.stopPropagation();
  store.dispatch('openNodeInMoveOrCopyModal', path);
}

function moveOrCopy(path, moveOrCopy) {
  store.commit('setNodesToMoveOrCopy', [path]);
  store.commit('setMoveOrCopy', moveOrCopy);
  store.commit('setSelectedNotMovableNodes', []);
  store.commit('setSelectedNotCopiableNodes', []);
  vm.$bvModal.show('move-or-copy-modal');
}

export default {
  showError(message) {
    vm.$bvToast.toast(message, {
      title: 'Error',
      variant: 'danger',
      solid: true
    });
  },
  showInfo(message) {
    vm.$bvToast.toast(message, {
      title: 'Info',
      variant: 'info',
      solid: true
    });
  }
}
